import React, { useContext, useState } from 'react';
import PrincipalComunicados from './Comunicados/PrincipalComunicados';
import { ContextGloball } from './Context/ContextGlobal';
import PrincipalSocial from './RedSocial/PrincipalSocial';
import PrincipalItinerario from './Itinerario/PrincipalItinerario';
import PrincipalFormulario from './Formularios/PrincipalFormulario';
import PrincipalAdminFormulario from './Formularios/PrincipalAdminFormulario';
import PrincipalVisita from './Reportes/PrincipalVisita';
import SettingCredenciales from './Login/SettingCredenciales';
import PrinciparSupervision from './Supervision/PrinciparSupervision';
import PrincipalAlmacen from './Almacenes/PrincipalAlmacen';
import MenuReportes from './Reportes/MenuReportes';
import MenuPrincipalRH from './Modulorrhh/MenuPrincipalRH';
import MenuProtocolos from './Protocolos/MenuProtocolos';
import MenuConfigWeb from './ConfiguraWeb/MenuConfigWeb';
import PerfilUsuario from './Login/PerfilUsuario';
import Revista from './PaginaRevista/Revista'


const server = process.env.REACT_APP_SERVER;

function Contenido({ regional }) {
    const { ventana } = useContext(ContextGloball);
    const [valor,setValor] = useState(0);
    if (ventana === '1') {
        return (
            <MenuConfigWeb />
        );
    } else if (ventana === '3') {
        return (
            <PrincipalVisita />
        );
    } else if (ventana === '4') {
        return (
            <PrincipalComunicados regional={regional} tipo='C' />
        );
    } else if (ventana === '5') {
        return (
            <MenuPrincipalRH />
        );
    } else if (ventana === '0') {
        return (
            <>
                <div className='container-fluid py-4'>
                    <div className="card bg-dark bg-gradient">
                        <div className="card-header text-light text-center">
                            BIENVENIDO AL SISTEMA
                        </div>
                        <div className="card-body">
                            <h5 className="card-title text-light">INGRESA AL MENU DE HERRAMIENTAS</h5>
                            <p className="card-text text-light">En la parte superior derecha se encuentra este icono&nbsp;&nbsp;&nbsp;<i className="fa-solid fa-bars fa-fade fa-2xl"></i>&nbsp;&nbsp;&nbsp;,
                                donde podras ver una lista de opciones que usted tiene permiso para visualizar... GRACIAS</p>
                        </div>
                    </div>
                </div>
            </>
        );
    } else if (ventana === '7') {
        return (
            <SettingCredenciales regional={regional} />
        );
    } else if (ventana === '8') {
        return (
            <PerfilUsuario/>
        );
    } else if (ventana === '11') {
        return (
            <MenuProtocolos />
        );
    } else if (ventana === '12') {
        return (
            <PrincipalSocial />
        );
    } else if (ventana === '13') {
        return (
            <PrincipalItinerario />
        );
    } else if (ventana === '15') {
        return (
            <></>
        );
    } else if (ventana === '16') {
        return (
            <MenuReportes />
        );
    } else if (ventana === '19') {
        return (
            <></>
        );
    } else if (ventana === '21') {
        return (
            <PrincipalFormulario tipo={null} callback={() => { }} />
        );
    } else if (ventana === '22') {
        return (
            <PrincipalAdminFormulario />
        );
    } else if (ventana === '27') {
        return (
            <></>
        );
    } else if (ventana === '28') {
        return (
            <></>
        )
    } else if (ventana === '29') {
        return (
            <></>
        )
    } else if (ventana === '30') {
        return (
            <></>
        )
    } else if (ventana === '36') {
        return (
            <PrinciparSupervision />
        )
    } else if (ventana === '37') {
        return (
            <></>
        )
    } else if (ventana == '41') {
        return (
            <PrincipalAlmacen />
        )
    }
    else if (ventana == '42') {
        return (
            <Revista />
        )
    }
}
export default Contenido;